/**
 * Banner visible en el header cuando hay una impersonación activa
 * Muestra quién está siendo suplantado y permite revertir rápidamente
 */

import { useAuth } from '@/auth/useAuth';
import { AlertTriangle } from 'lucide-react';
import { useState } from 'react';

export function ImpersonationBanner() {
  const { user, isImpersonating, revertImpersonation, originalUser } = useAuth();
  const [loading, setLoading] = useState(false);

  // No mostrar si no hay impersonación
  // O si es una "auto-impersonación" de SYSADMIN a ADMIN (Switch to Admin)
  const isAutoAdmin = originalUser?.userRole === 'SYSADMIN' && user?.asesor?.rol === 'ADMIN';

  if (!isImpersonating || isAutoAdmin) {
    // Limpiar CSS variable cuando no hay impersonación visible
    if (typeof document !== 'undefined') {
      document.documentElement.style.setProperty('--banner-height', '0px');
    }
    return null;
  }

  const handleRevert = async () => {
    setLoading(true);
    try {
      await revertImpersonation();
      // El componente se refresca automáticamente cuando isImpersonating cambia
    } catch (error) {
      console.error('Error al revertir impersonación:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="z-50 bg-teal-200 text-black px-4 py-3 flex items-center justify-between text-sm font-semibold shadow-md">
      <div className="flex items-center gap-3">
        <AlertTriangle className="w-5 h-5 shrink-0" />
        <span>
          Accediendo como: <strong>{user?.email}</strong>
        </span>
      </div>
      <button
        onClick={handleRevert}
        disabled={loading}
        className="bg-black text-white px-4 py-1.5 rounded text-xs font-bold hover:bg-gray-800 disabled:opacity-50 transition-colors"
      >
        {loading ? 'Revirtiendo...' : 'Volver'}
      </button>
    </div>
  );
}
